// Source UNIQUE — couleur de badge de statut → PAIRE dual-mode --oh-stat-*.
// Prend une classe Tailwind de fond (bg-emerald-500, bg-gray-600, bg-cyan-500/20)
// telle que stockée en config statut, et renvoie {background,color,border} lisible
// dans les 2 modes PAR CONSTRUCTION. Fini le "text-white sur fond clair" illisible :
// le texte est TOUJOURS le --oh-stat-*-text (couleur saturée) sur son -bg (tint),
// paire pensée pour contraster en clair ET en foncé (cf. index.css .dark/.light).
//
// Familles disponibles : blue, green, red, yellow, cyan, purple, orange, amber, slate.
const FAMILY = {
  emerald: "green", green: "green", teal: "green", lime: "green",
  blue: "blue", sky: "blue", indigo: "blue",
  cyan: "cyan",
  amber: "amber", orange: "orange", yellow: "yellow",
  red: "red", rose: "red",
  purple: "purple", violet: "purple", fuchsia: "purple", pink: "purple",
  gray: "slate", slate: "slate", zinc: "slate", stone: "slate", neutral: "slate",
};

// Extrait la famille depuis une classe Tailwind ("bg-emerald-500" → "emerald").
export function statutFamily(couleur) {
  const m = /([a-z]+)-\d/.exec(String(couleur || ""));
  return (m && FAMILY[m[1]]) || "slate";
}

// Style inline dual-mode pour un <Badge> de statut. Utiliser avec className="border-0".
export function statutBadgeStyle(couleur) {
  const fam = statutFamily(couleur);
  return {
    background: `var(--oh-stat-${fam}-bg)`,
    color: `var(--oh-stat-${fam}-text)`,
    border: `1px solid var(--oh-stat-${fam}-border)`,
  };
}
